"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ResourceFilterableCollection_1 = require("../DataModel/Collections/ResourceFilterableCollection");
const namespaces_1 = require("../namespaces");
const templatedOperationsExtractor_1 = require("./templatedOperationsExtractor");
function apiDocumentation(mappings) {
    mappings[namespaces_1.hydra.description] = {
        propertyName: "description",
        type: [namespaces_1.hydra.ApiDocumentation]
    };
    mappings[namespaces_1.hydra.title] = {
        propertyName: "displayName",
        type: [namespaces_1.hydra.ApiDocumentation]
    };
    mappings[namespaces_1.hydra.supportedClass] = {
        default: supportedClasses => new ResourceFilterableCollection_1.default(supportedClasses),
        propertyName: "supportedClasses",
        required: true,
        type: [namespaces_1.hydra.ApiDocumentation]
    };
    mappings[namespaces_1.hydra.entrypoint] = {
        default: entryPoints => (entryPoints.length > 0 ? entryPoints[0].iri : ""),
        propertyName: "entryPoint",
        required: true,
        type: [namespaces_1.hydra.ApiDocumentation]
    };
    mappings[namespaces_1.hydra.readable] = {
        default: false,
        propertyName: "readable",
        required: true,
        type: [namespaces_1.hydra.SupportedProperty]
    };
    mappings[namespaces_1.hydra.writeable] = {
        default: false,
        propertyName: "writable",
        required: true,
        type: [namespaces_1.hydra.SupportedProperty]
    };
    mappings[namespaces_1.hydra.supportedOperation] = {
        default: templatedOperationsExtractor_1.templatedOperationsExtractor,
        propertyName: "supportedOperations",
        required: true,
        type: [namespaces_1.hydra.Class, namespaces_1.hydra.Link, namespaces_1.hydra.TemplatedLink]
    };
    mappings[namespaces_1.hydra.supportedProperty] = {
        default: properties => new ResourceFilterableCollection_1.default(properties),
        propertyName: "supportedProperties",
        required: true,
        type: [namespaces_1.hydra.Class]
    };
    return mappings;
}
exports.apiDocumentation = apiDocumentation;
//# sourceMappingURL=apiDocumentation.js.map